module.exports = __webpack_public_path__ + "static/media/31.013.615fcb3a.webp";